/**
 * Geometria das marcas do lexico.
 *
 * Tudo sao caminhos calculados: sem `pattern`, sem `clipPath`, sem ids
 * gerados. Duas consequencias praticas — a marcacao e deterministica (logo
 * comparavel em teste) e nao ha ids duplicados quando a mesma marca aparece
 * varias vezes na pagina.
 */

export const CX = 11;
export const CY = 11;
export const R = 8.5;

/**
 * Segmento circular preenchido a partir da base, para a fraccao `f`.
 * f=1 devolve o disco cheio; f=0 devolve caminho vazio.
 */
export function fillFromBottom(f: number, cx = CX, cy = CY, r = R): string {
  if (f >= 1) return `M ${cx - r} ${cy} a ${r} ${r} 0 1 0 ${r * 2} 0 a ${r} ${r} 0 1 0 ${-r * 2} 0 Z`;
  if (f <= 0) return '';
  const y = cy + r - 2 * r * f;
  const w = Math.sqrt(Math.max(0, r * r - (y - cy) * (y - cy)));
  const largeArc = f > 0.5 ? 1 : 0;
  const n = (v: number) => Math.round(v * 100) / 100;
  // sweep 0 percorre o arco inferior (y cresce para baixo em SVG)
  return `M ${n(cx - w)} ${n(y)} A ${r} ${r} 0 ${largeArc} 0 ${n(cx + w)} ${n(y)} Z`;
}

/**
 * Linhas de tracejado a 45 graus contidas no circulo.
 * Mais linhas = mais contestado. E a densidade que ordena, nao a cor.
 */
export function hatchLines(count: number, cx = CX, cy = CY, r = R): { x1: number; y1: number; x2: number; y2: number }[] {
  const s = Math.SQRT1_2;
  const nx = s;
  const ny = -s;
  const tx = s;
  const ty = s;
  const out: { x1: number; y1: number; x2: number; y2: number }[] = [];
  const step = (2 * r * 0.82) / (count + 1);
  const n = (v: number) => Math.round(v * 100) / 100;
  for (let i = 1; i <= count; i += 1) {
    const d = -r * 0.82 + i * step;
    const L = Math.sqrt(Math.max(0, r * r - d * d));
    out.push({
      x1: n(cx + d * nx - L * tx),
      y1: n(cy + d * ny - L * ty),
      x2: n(cx + d * nx + L * tx),
      y2: n(cy + d * ny + L * ty),
    });
  }
  return out;
}

export const DIAMOND = `M ${CX} 2 L 20 ${CY} L ${CX} 20 L 2 ${CY} Z`;
